import {Component, HostListener, Injector, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {RdstationService} from '../../core/services/rdstation.service';
import {Meta, Title} from '@angular/platform-browser';
import {BaseComponents} from '../../shared/base-components';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AppComponent} from '../../app.component';
import {TYPE_META} from '../../core/constants/meta_title.constant';

@Component({
    selector: 'app-indique-e-ganhe',
    templateUrl: './indique-e-ganhe.component.html',
    styleUrls: ['./indique-e-ganhe.component.sass']
})
export class IndiqueEGanheComponent extends BaseComponents implements OnInit {

    form: FormGroup;
    submited = false;
    public specialCharacterRegex = /[()"'!@#$%^&\-*,.?:;{}|<>/´`~˜_]/;
    public mostrarMensagemSucesso = false;
    termoDeUsoAceito = false;
    constructor(
        protected injector: Injector,
        protected titleService: Title,
        protected meta: Meta,
        private rdstationService: RdstationService,
        public formBuilder: FormBuilder,
        public toast: ToastrService,
        public appComponent: AppComponent) {
        super(injector);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.handleMobile();
    }

    ngOnInit() {
        this.handleMobile();
        super.ngOnInit();
        this.setMetaTitle(TYPE_META.INDIQUE_GANHE);
        this.form = this.formInit();
    }

    formInit(): FormGroup {
        return this.form = this.formBuilder.group({
            name: ['', Validators.required],
            email: ['', Validators.required],
            cf_telefone_do_indicante: ['', Validators.required],
            cf_cpf_indicante: ['', Validators.required],
            cf_nome_do_indicado_1: ['', Validators.required],
            cf_telefone_do_indicado_1: ['', Validators.required],
            cf_email_do_indicado_1: ['', Validators.required],
            cf_nome_do_indicado_2: [''],
            cf_telefone_do_indicado_2: [''],
            cf_nome_do_indicado_3: [''],
            cf_telefone_do_indicado_3: [''],
            cf_nome_do_indicado_4: [''],
            cf_telefone_do_indicado_4: [''],
            cf_nome_do_indicado_5: [''],
            cf_telefone_do_indicado_5: [''],
            cf_nome_do_indicado_6: [''],
            cf_telefone_do_indicado_6: [''],
            cf_nome_do_indicado_7: [''],
            cf_telefone_do_indicado_7: [''],
            cf_nome_do_indicado_8: [''],
            cf_telefone_do_indicado_8: [''],
            cf_nome_do_indicado_9: [''],
            cf_telefone_do_indicado_9: [''],
            cf_nome_do_indicado_10: [''],
            cf_telefone_do_indicado_10: [''],
        });
    }

    showError(value: string) {
        if (this.submited) {
            return this.form.controls[value].errors;
        }
        return this.form.controls[value].invalid && (this.form.controls[value].dirty || this.form.controls[value].touched);
    }

    getErrorMessage(value: string) {
        const input = this.form.get(value);
        return input.hasError('required') ?
            'Campo obrigatório!' :
                input.hasError('invalidSpecialCharacter') ?
                    'Caracteres especiais não são permitidos!' :
                        input.hasError('invalidEmail') ?
                            'Endereço de e-mail inválido !' :
                            input.hasError('minlength') ?
                                'Digite exatamente 11 números sem Caracteres especiais!' :
                                '';
    }
    getPayload() {
        const {
            name,
            email,
            cf_telefone_do_indicante,
            cf_cpf_indicante,
            cf_nome_do_indicado_1,
            cf_telefone_do_indicado_1,
            cf_nome_do_indicado_2,
            cf_telefone_do_indicado_2,
            cf_nome_do_indicado_3,
            cf_telefone_do_indicado_3,
            cf_nome_do_indicado_4,
            cf_telefone_do_indicado_4,
            cf_nome_do_indicado_5,
            cf_telefone_do_indicado_5,
            cf_nome_do_indicado_6,
            cf_telefone_do_indicado_6,
            cf_nome_do_indicado_7,
            cf_telefone_do_indicado_7,
            cf_nome_do_indicado_8,
            cf_telefone_do_indicado_8,
            cf_nome_do_indicado_9,
            cf_telefone_do_indicado_9,
            cf_nome_do_indicado_10,
            cf_telefone_do_indicado_10,
        } = this.transformBeforeSave();
        return {
            conversion_identifier: 'formulario-indicacao-novo-site',
            name,
            email,
            cf_telefone_do_indicante,
            cf_cpf_indicante,
            cf_nome_do_indicado_1,
            cf_telefone_do_indicado_1,
            cf_nome_do_indicado_2,
            cf_telefone_do_indicado_2,
            cf_nome_do_indicado_3,
            cf_telefone_do_indicado_3,
            cf_nome_do_indicado_4,
            cf_telefone_do_indicado_4,
            cf_nome_do_indicado_5,
            cf_telefone_do_indicado_5,
            cf_nome_do_indicado_6,
            cf_telefone_do_indicado_6,
            cf_nome_do_indicado_7,
            cf_telefone_do_indicado_7,
            cf_nome_do_indicado_8,
            cf_telefone_do_indicado_8,
            cf_nome_do_indicado_9,
            cf_telefone_do_indicado_9,
            cf_nome_do_indicado_10,
            cf_telefone_do_indicado_10,
        };
    }
    getNewPayload() {
        const {
            name,
            email,
            cf_telefone_do_indicante,
            cf_cpf_indicante,
            cf_nome_do_indicado_1,
            cf_telefone_do_indicado_1,
            cf_email_do_indicado_1,
        } = this.transformBeforeSave();
        return {
            conversion_identifier: 'formulario-indicacao-novo-site',
            name,
            email,
            cf_telefone_do_indicante,
            cf_cpf_indicante,
            cf_nome_do_indicado_1,
            cf_nome_do_indicado: cf_nome_do_indicado_1,
            cf_telefone_do_indicado_1,
            cf_telefone_do_indicado: cf_telefone_do_indicado_1,
            cf_email_do_indicado_1,
            cf_email_do_indicado: cf_email_do_indicado_1,
        };
    }
    async onSave() {
        this.appComponent.showOverlay();
        if (this.form.invalid) {
            this.submited = true;
            this.toast.error('É necessário preencher todos os campos corretamente', '', {
                timeOut: 5000
            });
            this.appComponent.hideOverlay();
            return;
        }
        const body = {
            event_type: 'CONVERSION',
            event_family: 'CDP',
            payload: this.getNewPayload(),
        };
        await this.rdstationService
            .indicar(body)
            .then(item => {
                if (item.status !== 200) {
                    this.toast.error('Ocorreu um erro ao processar a sua requisição', '', {
                        timeOut: 5000
                    });
                    return;
                }
                this.mostrarMensagemSucesso = true;
                this.form.reset();
            })
            .catch(() => {
                this.toast.error('Ocorreu um erro ao processar a sua requisição', '', {
                    timeOut: 5000
                });
            }).finally(() => {
                this.appComponent.hideOverlay();
            });
    }

    validate(value: string, type: string) {
        const controls = this.form.controls[value];
        let regex = /^/;
        switch (type.toUpperCase()) {
            case 'SPECIAL_CHARACTER':
                regex = this.specialCharacterRegex;
                if (regex.test(controls.value)) {
                    controls.setErrors({invalidSpecialCharacter: true});
                }
                break;
            case 'EMAIL':
                regex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
                if (!regex.test(controls.value)) {
                    controls.setErrors({invalidEmail: true});
                }
                break;
            default:
                controls.setErrors({invalidField: true});
                break;
        }
    }

    transformBeforeSave() {
        return Object.assign({}, this.form.value);
    }

    termoDeUsoAceitoEmit($event: any) {
        this.termoDeUsoAceito = $event;
    }
}
